let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("deyvi"), load("cdeuH"), load("4UPfH"), load("aNg21"), load("1Mp9N"), load("2Fu3d")]).then(() => parcelRequire('7HAe3'));